import axios from "axios";
import { clearAuthToken, getAuthToken } from "../auth/authStorage";

export const API_ORIGIN = "https://stocksleuth.xyz:5000";
export const AUTH_INVALID_EVENT = "stocksleuth:auth-invalid";
export const apiClient = axios.create({ baseURL: API_ORIGIN, timeout: 30000 });

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  const target = new URL(config.url || "", config.baseURL || API_ORIGIN);
  if (!config.skipAuth && token && target.origin === API_ORIGIN) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
apiClient.interceptors.response.use((response) => response, (error) => {
  if (error.response?.status === 401) {
    clearAuthToken();
    window.dispatchEvent(new CustomEvent(AUTH_INVALID_EVENT));
  }
  return Promise.reject(error);
});

export const publicRequest = (config) => apiClient.request({ ...config, skipAuth: true });
export async function apiFetch(url, options = {}) {
  const response = await apiClient.request({
    url,
    method: options.method || "GET",
    headers: options.headers,
    data: typeof options.body === "string" ? JSON.parse(options.body) : options.body,
    signal: options.signal
  });
  return { ok: true, status: response.status, json: async () => response.data };
}
export default apiClient;
